import React from 'react';
import { observer } from 'mobx-react';
import { View, StyleSheet } from 'react-native';

import Text from '../shared/Text';
import Image from '../shared/Image';

import heroStore from '../../stores/hero';
import { isFull } from '../../utils/warriorUtils';

import { HP_HEIGHT, MARGIN_15, MARGIN_5, pOrT, RED, BASE_COLOR } from '../styleConstants';
import { formatNumber } from '../../utils/utils';

const WIDTH = pOrT(230, 320);

const styles = StyleSheet.create({
  container: {
    width: WIDTH,
    height: HP_HEIGHT,
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {},
});

export default observer(() => {
  const { current, max } = heroStore.hero.feature.capacity;
  return (
    <View>
      <Image
        style={{
          width: WIDTH,
          height: HP_HEIGHT,
          position: 'absolute',
        }}
        resizeMode="stretch"
        source={require('../../assets/images/paper4.png')}
      />
      <View style={styles.container}>
        <Image
          style={{
            width: pOrT(17, 19),
            height: pOrT(17, 19),
            marginLeft: MARGIN_15,
          }}
          source={require('../../assets/images/greed.png')}
        />
        <Text bold style={{ marginLeft: MARGIN_5, width: pOrT(70, 90) }}>
          {formatNumber(heroStore.hero.money)}
        </Text>
        <Image
          style={{
            marginLeft: MARGIN_15,
            width: pOrT(17, 19),
            height: pOrT(17, 19),
          }}
          source={require('../../assets/images/bag.png')}
        />
        <View style={{ marginLeft: MARGIN_5, flexDirection: 'row' }}>
          <Text bold style={[styles.text, { color: isFull(heroStore.hero) ? RED : BASE_COLOR }]}>
            {current}
          </Text>
          <Text>{' / '}</Text>
          <Text bold style={styles.text}>
            {max}
          </Text>
        </View>
      </View>
    </View>
  );
});
